import { useContext } from 'react';
import { RouterProvider } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { SnackbarProvider } from 'notistack';
import { AdminRealtimeProvider } from '@modules/admin';
import { ActiveEnterpriseProvider } from '@modules/enterprise';
import { AuthProvider } from '@modules/iam';
import router from '../router/routes';
import ErrorBoundary from '../shell/ErrorBoundary';
import { ThemeSettingsContext, ThemeSettingsProvider } from '../theme/ThemeSettingsProvider';
import { TourProvider } from '../tours/TourProvider';

function ThemedApp() {
  const themeSettings = useContext(ThemeSettingsContext);
  if (!themeSettings) {
    throw new Error('ThemedApp must be used within a ThemeSettingsProvider');
  }

  return (
    <ThemeProvider theme={themeSettings.theme}>
      <CssBaseline />
      <SnackbarProvider maxSnack={3} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
        <AuthProvider>
          <AdminRealtimeProvider>
            <ActiveEnterpriseProvider>
              <TourProvider>
                <ErrorBoundary>
                  <RouterProvider router={router} />
                </ErrorBoundary>
              </TourProvider>
            </ActiveEnterpriseProvider>
          </AdminRealtimeProvider>
        </AuthProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export function AppProviders() {
  return (
    <ThemeSettingsProvider>
      <ThemedApp />
    </ThemeSettingsProvider>
  );
}